// ===========================================
// Teacher Notification Preferences Page
// ===========================================
// Allows teachers to manage their multi-channel notification preferences

import { NotificationPreferencesForm } from '../../components/notifications';
import {
  teacherNotificationTypeLabels,
  teacherNotificationTypeDescriptions,
  teacherNotificationTypeOrder,
} from '../../api/notifications.api';

// ===========================================
// COMPONENT
// ===========================================

export default function TeacherNotificationPreferencesPage() {
  return (
    <NotificationPreferencesForm
      notificationTypeOrder={teacherNotificationTypeOrder}
      notificationTypeLabels={teacherNotificationTypeLabels}
      notificationTypeDescriptions={teacherNotificationTypeDescriptions}
      breadcrumbs={[
        { label: 'Teacher', path: '/teacher' },
        { label: 'Notifications' },
      ]}
    />
  );
}
